import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  courses: [],
  courseByCompany: [],
  sortedCourses: [],
  error: "",
};

const library = createSlice({
  name: "library",
  initialState,
  reducers: {
    allCourses: (state, action) => {
      state.courses = action.payload;
    },
    sortCourses: (state, action) => {
      state.sortedCourses = action.payload;
    },
    coursesByCompany: (state, action) => {
      state.courseByCompany = action.payload;
    },
    bookmarkById: (state, action) => {
      state.courses = action.payload;
    },
    clearCoursesByCompany: (state, action) => {
      state.courseByCompany = [];
    },
  },
});

export const {
  allCourses,
  bookmarkById,
  sortCourses,
  coursesByCompany,
  clearCoursesByCompany,
} = library.actions;

export default library.reducer;

export const selectedCourses = (state) => state.library.courses;
export const selectedCoursesByCompany = (state) => state.library.courseByCompany;
export const selectedSortedCourses = (state) => state.library.sortedCourses;
